// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b7cc8944","498":"8d7626aa","703":"004a1197"}[chunkId] + ".chunk.js";
};